export default __webpack_public_path__ + "static/media/glrc_tile.29b28694.jpg";